var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShareButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 27,
    viewBox: "0 0 24 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9812 18.1453C18.1883 18.1453 17.4498 18.3705 16.827 18.7579L8.88145 14.4695C8.98236 14.1253 9.03753 13.7622 9.03753 13.3863C9.03753 13.0104 8.98236 12.6473 8.88145 12.3032L16.6573 8.13051C17.3135 8.58601 18.115 8.85475 18.9812 8.85475C21.2007 8.85475 22.9999 7.09639 22.9999 4.9274C22.9999 2.75841 21.2007 1 18.9812 1C16.7618 1 14.9625 2.75836 14.9625 4.92735C14.9625 5.2138 14.9947 5.49279 15.0543 5.7618L7.12317 10.0404C6.51104 9.67197 5.79048 9.459 5.01876 9.459C2.79929 9.459 1 11.2174 1 13.3863C1 15.5553 2.79923 17.3137 5.01876 17.3137C5.79042 17.3137 6.51104 17.1007 7.12317 16.7323L15.1027 21.0439C15.0118 21.3719 14.9625 21.7166 14.9625 22.0727C14.9625 24.2416 16.7618 26 18.9812 26C21.2007 26 23 24.2416 23 22.0727C23 19.9037 21.2007 18.1453 18.9812 18.1453Z",
    stroke: "current",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareButton);
export default __webpack_public_path__ + "static/media/shareButton.af7eb6495cbbdcc5c3d58eca5d0f39f7.svg";
export { ForwardRef as ReactComponent };